import React from "react";

/**
 * Loading component for the Missed-Pickup page
 * Displays a loading state while the missed-pickup data is being fetched
 */
const MissedPickupLoading: React.FC = () => {
    return (
        <pui-stack>
            <div className="pui-loading-text-large-dark" style={{ marginBottom: "16px" }} />
            <div className="pui-loading-text-medium-dark" style={{ marginBottom: "24px" }} />

            {/* Pickup location loading skeleton */}
            <div className="pui-loading-text-medium-dark" style={{ marginBottom: "8px" }} />
            <div className="pui-loading-text-small-dark" style={{ marginBottom: "4px" }} />
            <div className="pui-loading-text-small-dark" style={{ marginBottom: "4px" }} />
            <div className="pui-loading-text-small-dark" style={{ marginBottom: "24px" }} />

            {/* Message loading skeleton */}
            <div className="pui-loading-text-small-dark" style={{ marginBottom: "4px" }} />
            <div className="pui-loading-text-small-dark" style={{ marginBottom: "24px" }} />

            {/* Order summary loading skeleton */}
            <div className="pui-loading-text-medium-dark" style={{ marginBottom: "16px" }} />
            <div className="pui-loading-card-dark" style={{ height: "80px", marginBottom: "16px" }} />
        </pui-stack>
    );
};

export default MissedPickupLoading;
